module.exports = __webpack_public_path__ + "static/1-18499d443e8b3b2b6ba6ff77902bcdde.svg";